__turbopack_context__.v({
  "activity-items-wrapper": "styles-module__ZFT4Tq__activity-items-wrapper",
  "text-responsive": "styles-module__ZFT4Tq__text-responsive",
});
